import Service from "../../../Services/index";

const ProductOverview = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        get({ commit }, {page,data}) {
            return Service.productOverview.getProductOverview(page,data);
        },
    }
};

export default ProductOverview;
